import { useEffect } from "react";

import CONFIG from "config/config";

type AppConfigType = Partial<
  Record<
    typeof CONFIG.COMPANY,
    {
      icon: string;
      name: string;
      subfix: string;
    }
  >
>;

const DEFAULT = {
  icon: "ih.png",
  name: "IH Platform",
  subfix: "",
};

const APP_CONFIG: AppConfigType = {
  MEHEALTH: {
    icon: "mehey-pro.png",
    name: "IsHealth Cloud",
    subfix: "-mehey-pro",
  },
};

const AppMetadata = () => {
  useEffect(() => {
    const appConfig = APP_CONFIG[CONFIG.COMPANY] ?? DEFAULT;

    const version = process.env.REACT_APP_BUILDVERSION || "";
    const formattedVersion = version ? ` (${version})` : "";

    // อัพเดท title
    document.title = `${appConfig.name}${formattedVersion}`;

    // อัพเดท favicon
    const favicon: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");

    if (favicon) {
      favicon.href = `${process.env.PUBLIC_URL}/${appConfig.icon}`;
    }

    // อัพเดท manifest link
    let manifestLink: HTMLLinkElement | null = document.querySelector('link[rel="manifest"]');

    if (!manifestLink) {
      manifestLink = document.createElement("link");
      manifestLink.rel = "manifest";
      document.head.append(manifestLink);
    }

    manifestLink.href = `${process.env.PUBLIC_URL}/manifest${appConfig.subfix}.json`;
  }, []);

  return null;
};

export default AppMetadata;
